require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /home/deploy/gamba/shared/rnclient/node_modules/core-js/library/modules/es7.symbol.observable.js
// module id = 2405
// module chunks = 4